import {
  faInstagram as freeFabFaInstagram,
  faLinkedin as freeFabFaLinkedin,
  faTiktok as freeFabFaTiktok,
  faXTwitter as freeFabFaXTwitter
} from '@fortawesome/free-brands-svg-icons'

import {
  faCog as freeFasFaCog,
  faCreditCard as freeFasFaCreditCard,
  faSignOutAlt as freeFasFaSignOutAlt,
  faTimes as freeFasFaTimes,
  faPlus as freeFasFaPlus,
  faBox as freeFasFaBox,
  faCoins as freeFasFaCoins,
  faUniversity as freeFasFaUniversity,
  faTrash as freeFasFaTrash,
  faEdit as freeFasFaEdit,
  faArrowLeft as freeFasFaArrowLeft,
  faArrowRight as freeFasFaArrowRight,
  faArrowUp as freeFasFaArrowUp,
  faArrowDown as freeFasFaArrowDown,
  faPrint as freeFasFaPrint,
  faSave as freeFasFaSave,
  faCheck as freeFasFaCheck,
  faCheckSquare as freeFasFaCheckSquare,
  faTimesSquare as freeFasFaTimesSquare,
  faSquare as freeFasFaSquare,
  faFilePdf as freeFasFaFilePdf,
  faHome as freeFasFaHome,
  faClock as freeFasFaClock,
  faStopwatch as freeFasFaStopwatch,
  faCogs as freeFasFaCogs,
  faDatabase as freeFasFaDatabase,
  faChevronDown as freeFasFaChevronDown,
  faChevronUp as freeFasFaChevronUp,
  faChevronLeft as freeFasFaChevronLeft,
  faChevronRight as freeFasFaChevronRight,
  faProjectDiagram as freeFasFaProjectDiagram,
  faUserFriends as freeFasFaUserFriends,
  faInfoCircle as freeFasFaInfoCircle,
  faCheckCircle as freeFasFaCheckCircle,
  faTimesCircle as freeFasFaTimesCircle,
  faTriangleExclamation as freeFasFaTriangleExclamation,
  faUserCircle as freeFasFaUserCircle,
  faCalendarAlt as freeFasFaCalendarAlt,
  faFileInvoiceDollar as freeFasFaFileInvoiceDollar,
  faChartLine as freeFasFaChartLine,
  faUsers as freeFasFaUsers,
  faComments as freeFasFaComments,
  faQuestionCircle as freeFasFaQuestionCircle,
  faFileInvoice as freeFasFaFileInvoice,
  faFileAlt as freeFasFaFileAlt,
  faMoneyBillWave as freeFasFaMoneyBillWave,
  faTasks as freeFasFaTasks,
  faBars as freeFasFaBars,
  faList as freeFasFaList,
  faBusinessTime as freeFasFaBusinessTime,
  faChartBar as freeFasFaChartBar,
  faChartColumn as freeFasFaChartColumn,
  faSpinner as freeFasFaSpinner,
  faExternalLinkAlt as freeFasFaExternalLinkAlt,
  faCookie as freeFasFaCookie,
  faRedo as freeFasFaRedo
} from '@fortawesome/free-solid-svg-icons'

import {
  faUser as freeFarFaUser,
  faBell as freeFarFaBell,
  faQuestionCircle as freeFarFaQuestionCircle,
  faComment as freeFarFaComment,
  faEye as freeFarFaEye,
  faEdit as freeFarFaEdit,
  faTrashAlt as freeFarFaTrashAlt,
  faBuilding as freeFarFaBuilding,
  faRectangleList as freeFarFaRectangleList,
  faCheckCircle as freeFarFaCheckCircle,
  faTimesCircle as freeFarFaTimesCircle,
  faClock as freeFarFaClock
} from '@fortawesome/free-regular-svg-icons'

export default {freeFabFaInstagram, freeFabFaLinkedin, freeFabFaTiktok, freeFabFaXTwitter, freeFasFaCog, freeFasFaCreditCard, freeFasFaSignOutAlt, freeFasFaTimes, freeFasFaPlus, freeFasFaBox, freeFasFaCoins, freeFasFaUniversity, freeFasFaTrash, freeFasFaEdit, freeFasFaArrowLeft, freeFasFaArrowRight, freeFasFaArrowUp, freeFasFaArrowDown, freeFasFaPrint, freeFasFaSave, freeFasFaCheck, freeFasFaCheckSquare, freeFasFaTimesSquare, freeFasFaSquare, freeFasFaFilePdf, freeFasFaHome, freeFasFaClock, freeFasFaStopwatch, freeFasFaCogs, freeFasFaDatabase, freeFasFaChevronDown, freeFasFaChevronUp, freeFasFaChevronLeft, freeFasFaChevronRight, freeFasFaProjectDiagram, freeFasFaUserFriends, freeFasFaInfoCircle, freeFasFaCheckCircle, freeFasFaTimesCircle, freeFasFaTriangleExclamation, freeFasFaUserCircle, freeFasFaCalendarAlt, freeFasFaFileInvoiceDollar, freeFasFaChartLine, freeFasFaUsers, freeFasFaComments, freeFasFaQuestionCircle, freeFasFaFileInvoice, freeFasFaFileAlt, freeFasFaMoneyBillWave, freeFasFaTasks, freeFasFaBars, freeFasFaList, freeFasFaBusinessTime, freeFasFaChartBar, freeFasFaChartColumn, freeFasFaSpinner, freeFasFaExternalLinkAlt, freeFasFaCookie, freeFasFaRedo, freeFarFaUser, freeFarFaBell, freeFarFaQuestionCircle, freeFarFaComment, freeFarFaEye, freeFarFaEdit, freeFarFaTrashAlt, freeFarFaBuilding, freeFarFaRectangleList, freeFarFaCheckCircle, freeFarFaTimesCircle, freeFarFaClock}